
export function getCssScale(ele:HTMLElement){
	if(ele){
		let transform=ele.style.transform;
		if(transform.startsWith('matrix(')){
			transform=transform.substring(7,transform.length-1);
			const m=transform.split(',').map(v=>+v);
			if(m.length===6){
				const v=Math.SQRT1_2;
				return 1/Math.sqrt((m[0]*v+m[1]*v)**2+(m[2]*v+m[3]*v)**2);
			}
		}
	}
	return 1;
}

export function getTransform(ele:HTMLElement){
	if(!ele)
		return null;
	const styles=getComputedStyle(ele);
	let transform=styles.transform;
	const m=new DOMMatrix(transform);
	return m;
}